import OrderRequestClient from './OrderRequestClient'
import OrderRequestCart from './OrderRequestCart'

export default class OrderRequest {
  constructor ({ client, cart, billingCycle, loyaltyYears, paymentMethod }) {
    this.categoryCode = 'FW'
    this.client = new OrderRequestClient({ ...client })
    this.cart = new OrderRequestCart({ ...cart })
    this.billingCycle = billingCycle
    this.loyaltyYears = loyaltyYears
    this.paymentMethod = paymentMethod
  }
}
